import React, { useState } from 'react';

import _ from 'lodash';
import Promise from 'bluebird';
import classnames from 'classnames';
import FormField from 'scy/FormField';
import styles from './styles.mod.scss';
import { PrimaryButton, ConfirmButton } from 'scy/buttons';
import { SmallAlt } from 'scy/text';
import { Warning } from 'scy/Warning';
import { flex, flex1 } from 'scy/flex.mod.scss';
import { textLeft } from 'scy/utils.mod.scss';
import { thirdPartyAccountLink } from '../../../models/api';
import padding from 'scy/padding.mod.scss';

function validateEmail(email) {
  if (!email) return "Email can't be blank";
}

function validatePassword(password) {
  if (!password) return "Password can't be blank";
}

export default function AccountLinkForm({ initEmail, onSuccess }) {
  const [errors, setErrors] = useState({});
  const [asyncError, setAsyncError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState(initEmail || '');
  const [password, setPassword] = useState('');

  function validateFields() {
    let errors = {};
    errors.email = validateEmail(email) || null;
    errors.password = validatePassword(password) || null;
    setErrors(errors);
    if (_.some(errors)) return Promise.reject(new Error());
    return Promise.resolve();
  }

  function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setAsyncError(null);
    return validateFields()
      .then(() => thirdPartyAccountLink({ email, password }))
      .then(data => {
        console.log(`account link success:${JSON.stringify(data)}`); // eslint-disable-line no-console
        if (onSuccess) {
          onSuccess(data);
        }
      })
      .catch(({ message }) => {
        setLoading(false);
        setAsyncError(message);
      });
  }

  return (
    <div className={textLeft}>
      <form onSubmit={handleSubmit}>
        {!!asyncError && <Warning>{asyncError}</Warning>}

        <FormField
          id="user-email"
          name="email"
          labelText="Email"
          inputType="email"
          disabled={true}
          initialValue={email}
          onChange={setEmail}
          validate={validateEmail}
          error={errors.email}
        />

        <FormField
          id="user-password"
          name="password"
          labelText="Password"
          inputType="password"
          onChange={setPassword}
          validate={validatePassword}
          error={errors.password}
        />
        <SmallAlt
          colorClass={styles.lightGrey}
          className={classnames(
            styles.gtAmericaReg,
            padding.top_sm,
            padding.bottom_sm
          )}
        >
          By continuing I hereby attest that I am 21 years or older, consent to
          Emjay&apos;s Term of Service & Privacy Policy, and to use electronic
          records and signatures, and opt-in to receive communications from
          Emjay
        </SmallAlt>
        <div className={flex}>
          <PrimaryButton
            Button={ConfirmButton}
            color={styles.scyTeal}
            type="submit"
            className={flex1}
            disabled={loading}
            loading={loading}
          >
            Link Account
          </PrimaryButton>
        </div>
      </form>
    </div>
  );
}
